import { render, staticRenderFns } from "./PortfolioV2.vue?vue&type=template&id=0903ec65&scoped=true&"
import script from "./PortfolioV2.vue?vue&type=script&lang=js&"
export * from "./PortfolioV2.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioV2.vue?vue&type=style&index=0&id=0903ec65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0903ec65",
  null
  
)

export default component.exports